/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { Method,prepare,QueryStringArrayFormat,RequestBodyType,ResponseBodyType } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from './request';
// @ts-ignore
import makeRequestHook from './makeRequestHook';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://yapi.yishou.com/mock/187' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = '' as any;
const dataKey_0_0_0_0 = 'data' as any;

export interface BaobanPcExportRequest {
  file: string;
}

export interface BaobanPcExportResponse {}

type BaobanPcExportRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/187',
    '',
    '',
    '/baoban/CommonPc/baobanPcExport',
    'data',
    string,
    string,
    false
  >
>;

const baobanPcExportRequestConfig: BaobanPcExportRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baoban/CommonPc/baobanPcExport',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: 'object',
    required: ['file'],
    properties: { file: { type: 'string' } },
  },
  responseDataJsonSchema: { type: 'object', title: 'empty object', properties: {} },
  requestFunctionName: 'baobanPcExport',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

export const baobanPcExport = /*#__PURE__*/ (
  requestData: BaobanPcExportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcExportResponse>(
    prepare(baobanPcExportRequestConfig, requestData),
    ...args,
  );
};

baobanPcExport.requestConfig = baobanPcExportRequestConfig;

export const useBaobanPcExport = /*#__PURE__*/ makeRequestHook<
  BaobanPcExportRequest,
  BaobanPcExportRequestConfig,
  ReturnType<typeof baobanPcExport>
>(baobanPcExport);

export interface BaobanPcGetConfigRequest {}

export interface BaobanPcGetConfigResponse {
  categoryList?: {
    value: string;
    label: string;
    pid: string;
    grade: string;
    goods_weight: string;
    children: {
      value: string;
      label: string;
      pid: string;
      grade: string;
      goods_weight: string;
      children: {
        value: string;
        label: string;
        pid: string;
        grade: string;
        goods_weight: string;
      }[];
    }[];
    disabled: boolean;
    unchoose: number[];
  }[];
  obsUploadData?: {
    AccessKeyId?: string;
    policy?: string;
    signature?: string;
    success_action_status?: number;
    domain?: string;
  };
}

type BaobanPcGetConfigRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/187',
    '',
    '',
    '/baoban/CommonPc/baobanPcGetConfig',
    'data',
    string,
    string,
    true
  >
>;

const baobanPcGetConfigRequestConfig: BaobanPcGetConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baoban/CommonPc/baobanPcGetConfig',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: { type: 'object', required: [], properties: {} },
  responseDataJsonSchema: {
    type: 'object',
    properties: {
      categoryList: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            value: { type: 'string' },
            label: { type: 'string' },
            pid: { type: 'string' },
            grade: { type: 'string' },
            goods_weight: { type: 'string' },
            children: {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  value: { type: 'string' },
                  label: { type: 'string' },
                  pid: { type: 'string' },
                  grade: { type: 'string' },
                  goods_weight: { type: 'string' },
                  children: {
                    type: 'array',
                    items: {
                      type: 'object',
                      properties: {
                        value: { type: 'string' },
                        label: { type: 'string' },
                        pid: { type: 'string' },
                        grade: { type: 'string' },
                        goods_weight: { type: 'string' },
                      },
                      required: ['value', 'label', 'pid', 'grade', 'goods_weight'],
                    },
                  },
                },
                required: ['value', 'label', 'pid', 'grade', 'goods_weight', 'children'],
              },
            },
            disabled: { type: 'boolean' },
            unchoose: { type: 'array', items: { type: 'number' } },
          },
          required: [
            'value',
            'label',
            'pid',
            'grade',
            'goods_weight',
            'children',
            'disabled',
            'unchoose',
          ],
        },
      },
      obsUploadData: {
        type: 'object',
        properties: {
          AccessKeyId: { type: 'string' },
          policy: { type: 'string' },
          signature: { type: 'string' },
          success_action_status: { type: 'number' },
          domain: { type: 'string' },
        },
      },
    },
  },
  requestFunctionName: 'baobanPcGetConfig',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

export const baobanPcGetConfig = /*#__PURE__*/ (
  requestData?: BaobanPcGetConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetConfigResponse>(
    prepare(baobanPcGetConfigRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetConfig.requestConfig = baobanPcGetConfigRequestConfig;

export const useBaobanPcGetConfig = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetConfigRequest,
  BaobanPcGetConfigRequestConfig,
  ReturnType<typeof baobanPcGetConfig>
>(baobanPcGetConfig);

export interface BaobanPcDisabledCategoryListRequest {
  cat_id: string[];
}

export type BaobanPcDisabledCategoryListResponse = {
  value: string;
  label: string;
  pid: string;
  grade: string;
  goods_weight: string;
  children: {
    value: string;
    label: string;
    pid: string;
    grade: string;
    goods_weight: string;
    children: {
      value: string;
      label: string;
      pid: string;
      grade: string;
      goods_weight: string;
      disabled: boolean;
    }[];
    disabled: boolean;
  }[];
  unchoose: number[];
}[];

type BaobanPcDisabledCategoryListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/187',
    '',
    '',
    '/baoban/CommonPc/baobanPcDisabledCategoryList',
    'data',
    string,
    string,
    false
  >
>;

const baobanPcDisabledCategoryListRequestConfig: BaobanPcDisabledCategoryListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/baoban/CommonPc/baobanPcDisabledCategoryList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: 'object',
      title: 'empty object',
      properties: { cat_id: { type: 'array', items: { type: 'string' } } },
      required: ['cat_id'],
    },
    responseDataJsonSchema: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          value: { type: 'string' },
          label: { type: 'string' },
          pid: { type: 'string' },
          grade: { type: 'string' },
          goods_weight: { type: 'string' },
          children: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                value: { type: 'string' },
                label: { type: 'string' },
                pid: { type: 'string' },
                grade: { type: 'string' },
                goods_weight: { type: 'string' },
                children: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      value: { type: 'string' },
                      label: { type: 'string' },
                      pid: { type: 'string' },
                      grade: { type: 'string' },
                      goods_weight: { type: 'string' },
                      disabled: { type: 'boolean' },
                    },
                    required: ['value', 'label', 'pid', 'grade', 'goods_weight', 'disabled'],
                  },
                },
                disabled: { type: 'boolean' },
              },
              required: ['value', 'label', 'pid', 'grade', 'goods_weight', 'children', 'disabled'],
            },
          },
          unchoose: { type: 'array', items: { type: 'number' } },
        },
        required: ['value', 'label', 'pid', 'grade', 'goods_weight', 'children', 'unchoose'],
      },
    },
    requestFunctionName: 'baobanPcDisabledCategoryList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcDisabledCategoryList = /*#__PURE__*/ (
  requestData: BaobanPcDisabledCategoryListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcDisabledCategoryListResponse>(
    prepare(baobanPcDisabledCategoryListRequestConfig, requestData),
    ...args,
  );
};

baobanPcDisabledCategoryList.requestConfig = baobanPcDisabledCategoryListRequestConfig;

export const useBaobanPcDisabledCategoryList = /*#__PURE__*/ makeRequestHook<
  BaobanPcDisabledCategoryListRequest,
  BaobanPcDisabledCategoryListRequestConfig,
  ReturnType<typeof baobanPcDisabledCategoryList>
>(baobanPcDisabledCategoryList);

export interface BaobanFileUploadRequest {
  url: string;
}

export interface BaobanFileUploadResponse {
  url?: string;
}

type BaobanFileUploadRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/187',
    '',
    '',
    '/baoban/CommonPc/baobanFileUpload',
    'data',
    string,
    string,
    false
  >
>;

const baobanFileUploadRequestConfig: BaobanFileUploadRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baoban/CommonPc/baobanFileUpload',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: 'object',
    required: ['url'],
    properties: { url: { type: 'string' } },
  },
  responseDataJsonSchema: { type: 'object', properties: { url: { type: 'string' } } },
  requestFunctionName: 'baobanFileUpload',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

export const baobanFileUpload = /*#__PURE__*/ (
  requestData: BaobanFileUploadRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanFileUploadResponse>(
    prepare(baobanFileUploadRequestConfig, requestData),
    ...args,
  );
};

baobanFileUpload.requestConfig = baobanFileUploadRequestConfig;

export const useBaobanFileUpload = /*#__PURE__*/ makeRequestHook<
  BaobanFileUploadRequest,
  BaobanFileUploadRequestConfig,
  ReturnType<typeof baobanFileUpload>
>(baobanFileUpload);

/* prettier-ignore-end */
